<template>
  <div class="home">
    <div class="main">
      <Header></Header>
      <div class="main_center">
        <div class="search">
          <div class="search_info">
            <p class="main_slogan" style="width: 100%;">
              探索人体奥秘
            </p>
          </div>
          <div class="search_info">
            <div class="">
              <input v-model="input" @keyup.enter="search('search')" type="text" placeholder="Explore the Body in 3D"/>
              <Icon name="search" @click="search('search')" size="30px" color="#000" style="margin-top:7px;float:right;cursor: pointer;"/>
              <!-- <button @click="search('search')">查找模型</button> -->
            </div> 
            <button @click="search('all')">查看全部</button>
          </div>
        </div>
      </div>
    </div>
    <div class="announcement_wrap" v-if="noticeInfo">
        <div class="announcement">
            <img src="../assets/imgs/laba.png" alt="">
            <span>{{noticeInfo}}</span>
        </div>
    </div>
    <div class="home_list">
      <h2>学科分类</h2>
      <ul>
        <li v-for="(item,index) in subjectList" :key="index" v-show="item.zh_name !=='解剖测验'">
          <div class="home_list_info" @click="tosearch(item)">
              <img :src="item.img_path" alt="">
              <div class="home_list_text">
                <!-- <p style="margin-bottom:5px ;">{{item.name}}</p> -->
                <p>{{item.zh_name}}</p>
                <!-- <div class="home_list_btns">
                  <span>标签1 标签2 标签3</span>
                  <div>
                    <img src="../assets/imgs/查看2.png" alt="">
                    <img @click="collect(item)" src="../assets/imgs/收藏.png" alt="">
                  </div>
                </div> -->
              </div>
          </div>
        </li>
      </ul>
      <h2 style="margin:60px 0 30px 0; ">热门模型</h2>
      <ul>
        <li v-for="(item,index) in hotlists" :key="index">
          <div class="home_list_info1">
              <img :src="item.image" alt="" @click="todetail(item.detail_id,item.is_buy,item.link)">
              <div class="home_list_text">
                <p style="margin-bottom:5px;">{{item.zh_title}}</p>
                <div style="height:16px;"><span style="margin-right:10px;color:#999;font-size:12px;" v-for="(item,index) in item.zh_tags" :key="index">{{item}}</span></div>
                <div class="home_list_btns">
                  <span></span>
                  <div>
                    <img @click="todetail(item.detail_id,item.is_buy,item.link)" src="../assets/imgs/眼睛.png" alt="">
                    <img v-if="item.is_collection == 0 && type == 'user'" @click="collect(item.detail_id)" src="../assets/imgs/收藏 (3).png" alt="" >
                    <img v-if="item.is_collection == 1 && type == 'user'" @click="collect(item.detail_id)" src="../assets/imgs/收藏 (2).png" alt="" >
                  </div>
                </div>
              </div>
          </div>
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/HeaderView.vue'; // @ is an alias to /src
import Footer from '@/components/FooterView.vue';
import { Icon } from 'tdesign-icons-vue';
import {Message} from 'element-ui'
export default{
  components:{
    Header,
    Footer,
    Icon
  },
  data(){
    return{
      type:window.localStorage.getItem('method'),
      subjectList:[],
      input:'',
      hotlists:[],
      noticeInfo:'',
      timer2:null,
    }
  },
  
  created() {
      this.getList()
      this.hotlist()
      // 间隔一小时获取一次公告
      this.getNoticeInfo()
      this.timer2 = setInterval(() => {
          this.getNoticeInfo()
      }, 3600000)

  },
  mounted(){
  },
  methods:{
     // 获取公告内容
     getNoticeInfo() {
      this.$api.home.get_notice().then(res => {
            if (res.code == 200) {
                this.noticeInfo = res.data
            } else {
                this.noticeInfo = null
            }
        })

    },
    todetail(id,is_buy,link){
        if(is_buy == 0){
            Message.error('未购买当前学科')
        }else{
            window.open(link, '_blank')
            // this.$router.push({
            //     name:'detail',
            //     query:{
            //         detail_id:id,
            //         type:'zh'
            //     }
            // })
        }
        
    },
    hotlist(){
      this.$api.home.get_hot_detail()
      .then(res=>{
        if(res.code == 200){
          this.hotlists = res.data
        }
      })
    },  
    tosearch(item){
      var data = JSON.stringify({
        keyword:this.input,
        type:'',
        detail:'',
        sort:'correlation',
        category_id:item.category_id,
        page:1,
        size:30
      })
      this.$router.push({
        name:'search',
        query:{
          data:data
        }
      })
    },
    search(e){
      if(e == 'search'){
        if(this.input == ''){
          this.$message.warning('请输入检索词')
        }else{
          var data = JSON.stringify({
            keyword:this.input,
            type:'',
            detail:'',
            sort:'correlation',
            category_id:'all',
            page:1,
            size:30
          })
          this.$router.push({
            name:'search',
            query:{
              data:data
            }
          })
        }
      }else{
        var data1 = JSON.stringify({
          keyword:'',
          type:'',
          detail:'',
          sort:'correlation',
          category_id:'all',
          page:1,
          size:30
        })
        this.$router.push({
          name:'search',
          query:{
            data:data1
          }
        })
      }
        
    },  
    getList(){
        this.$api.home.all_catrgory()
        .then(res=>{
          if(res.code == 200){
              this.subjectList = res.data
          }
        })
    },
    collect(item){
        var data = {
            detail_id:item
        }
        this.$api.home.collection(data)
        .then(res=>{
            if(res.code == 200){
                this.$message.success(res.message)
                  this.hotlist()
            }else{
                this.$message.error(res.message)
            }
        })
    },
  }
}
</script>

<style scoped lang="less">
.home{
  width: 100%;
}
.main{
  background: url('../assets/imgs/biodigital-human-nervous-system.jpg')no-repeat;
  background-size: 100%;
  width: 100%;
  max-height: 60vh;
  padding-bottom:100px;
  .main_center{
    width: 70%;
    margin: 50px auto;
    color: #fff;
    .search{
      min-width: 530px;
      max-width: 530px;
      text-align: center; 
      .main_slogan{
        text-align: left;
        margin: 30px 10px;
        font-size: 35px;
      }
      .search_info{
        display: flex;
        justify-content: space-around;
        div{
          // display: flex;
          padding: 0 10px 0 20px;
          // justify-items: center;
          // align-items: center;
          width: 80%;
          background-color: #fff;
          border-radius: 20px;
          height: 45px;
          input{
            float:left;
            height: 100%;
            width: 90%;
            border: none;
            outline:none;
          }
          button{
            width:100px;
            height: 90%;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        button{
          color: #FFF;
          background: #0052d9;
          width:100px;
          border-radius: 20px;
          border: none;
          padding: 0 10px;
          margin-left: 20px;
        }
      }
    }
  }
}
.home_list{
  width: 80%;
  margin: 50px auto;
  h2{
    font-size: 25px;
    text-align: center;
    margin-bottom: 20px;
  }
  ul{
    width: 100%;
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    li{
      width: 20%;
      padding: 10px;
      .home_list_info{
        cursor: pointer;
        box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
        border-radius: 15px;
        padding: 10px 20px;
        overflow: hidden;
        display: flex;
        align-items: center;
        img{
          width: 10%;
          height: auto;
        }
        .home_list_text{
          width: 80%;
          padding: 5px 10px;
          margin-left: 5%;
          p{
            
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
 
          }
          .home_list_btns{
            display: flex;
            justify-content: space-between;
            align-items: center;
            div{
              img{
                width: 25px;
                margin-right: 10px;
                cursor: pointer;
              }
            }
          }
        }
      }
      .home_list_info1{
        box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
        border-radius: 15px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          height: auto;
          cursor: pointer;
        }
        .home_list_text{
          width: 100%;
          padding: 5px 10px;
          p{
            
            font-weight: 600;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
 
          }
          .home_list_btns{
            margin-top: 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            div{
              img{
                width: 25px;
                margin-right: 10px;
                cursor: pointer;
              }
            }
          }
        }
      }
      .home_list_info1:hover{
        transform: scale(1.1);
      }
      // .home_list_info1:hover .zhezhao {
      //   display: block;
      // }
    }
  }
}
.zhezhao{

  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 15px;
  text-align: center;
  div{
    font-weight: 600;
    color: #fff;
    font-size: 20px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
// 公告部分
.announcement_wrap {
    background: #ffce60;
}
.announcement {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    padding: 8px 0;
    align-items: center;
    color: #333;

    img {
        width: 24px;
        margin-right: 10px;
    }
}
</style>
